import { render, staticRenderFns } from "./LayerSwitch.vue?vue&type=template&id=bdd04b1a&scoped=true"
import script from "./LayerSwitch.vue?vue&type=script&lang=js"
export * from "./LayerSwitch.vue?vue&type=script&lang=js"
import style0 from "./LayerSwitch.vue?vue&type=style&index=0&id=bdd04b1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdd04b1a",
  null
  
)

export default component.exports